<template>
  <div class="login-bg">
    <transition name="fade">
      <div v-loading="true" style="width: 100%; height: 100%"></div>
    </transition>
  </div>
</template>
<script>
import Cookies from "js-cookie"
import { GetCode, LoginIn } from "../api/module/login"
export default {
  data() {
    return {
      loginForm: {
        username: "yanshi-hui",
        password: "111111",
        code: ""
      },
      loading: null
    }
  },

  methods: {
    // yan_shi/111111
    clearInfos() {
      sessionStorage.setItem("store", null) // session置空
      sessionStorage.removeItem("HEARDTOKENID")
      this.$store.commit("resetLoad", false)
      this.$store.commit("updateMainTabs", [])
    },
    initLoginInfo() {
      this.paintVeffyCode()
    },
    autoLogin(code) {
      const userInfo = {
        loginName: this.loginForm.username,
        loginPwd: this.loginForm.password,
        code: code
      }
      // console.log("userInfo--->", userInfo)

      LoginIn(
        userInfo,
        res => {
          const logerInfo = res.obj
          // 5-20   登录信息保存到缓存中
          Cookies.set("user", logerInfo)
          sessionStorage.setItem("loginUser", JSON.stringify(logerInfo)) // 关闭窗口后，登录信息不在
          // 将登陆信息保存到vuex
          this.$store.dispatch("recordLogInfo", logerInfo)
          this.$router.push({ path: "/homeStopOver" })
          Cookies.remove("hzfadminimagecode")
        },
        () => {
          setTimeout(() => {
            this.initLoginInfo()
          }, 5000)
        }
      )
    },
    // 前台画的验证码
    paintVeffyCode() {
      GetCode(null, res => {
        this.autoLogin(res.obj)
      })
    }
  },
  created() {},
  mounted() {
    this.clearInfos()
    this.$nextTick(() => {
      this.initLoginInfo()
    })
  }
}
</script>
<style scoped>
.login-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url("../../src/assets/3.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
